module.exports = __webpack_public_path__ + "static/media/2021-10-13 Energy and Commerce Mtg - DC edit_1637191801250.4eaaf2f6.pptx";